<style lang="scss">
	.baseedit .vview-formitem-label{
		text-align:center !important;
	}
	/* .baseedit .vview-formitem-label-wrapper{
		width:100% !important;
	} */

    .warehouse-info-form {
        .vview-formitem {
            line-height: 28px;
        }
    }
</style>
<template>
    <div>
		<!-- <Breadcrumb class="tablelist-header" v-if="!querytype">
            <BreadcrumbItem to="/">{{$t('erp.product.product_management',{defaultValue:'产品管理'})}}{{type==='edit'?$t('global.common.operation_edit',{defaultValue:'编辑'}):(type==='add'?$t('global.common.operation_add',{defaultValue:'添加'}):$t('global.common.operation_see',{defaultValue:'查看'}))}}</BreadcrumbItem>
        </Breadcrumb> -->
        <compWrapper :title="$t('global.common.base_information',{defaultValue:'基本信息'})" theme="primary">
            <Button v-if="type == 'query'" style="position: absolute; right: 10px; top: 2px;" type="warning" @click="downloadProduct">{{$t('erp.product.download_product_flag', { defaultValue: '下载产品标' })}}</Button>
            <compFormQuery v-if="type=='query'" class="margin-top-15 margin-right-15" :formdata="getBase" :value="formData" :labelWidth="120"></compFormQuery>
            <compFormEdit ref="baseform" v-else class="margin-top-15 margin-right-15 baseedit" :formdata="getBase" v-model="formData" :labelWidth="120"></compFormEdit>
			<template v-if="type!='query'" slot="footer">
				<vButton class="margin-right-20" theme="primary" @click="submit">{{$t('global.common.save',{defaultValue:'保存'})}}</vButton>
				<vButton class="margin-right-20" @click="cancel">{{$t('global.common.operation_cancel',{defaultValue:'取消'})}}</vButton>
			</template>
        </compWrapper>

		<compWrapper v-if="warehouseInfo" :title="$t('erp.product.warehouse_information',{defaultValue:'仓库发货信息'})" theme="warning">

			<compFormQuery v-if="type=='query'" class="warehouse-info-form margin-top-15 margin-right-15" :formdata="getWarehouse" :value="formData" :labelWidth="120"></compFormQuery>
			<compFormEdit ref="warehouseform" v-else class="warehouse-info-form margin-top-15 margin-right-15" :formdata="getWarehouse" v-model="formData" :labelWidth="120"></compFormEdit>
		</compWrapper>

		<compWrapper v-if="packageInfo" :title="$t('erp.product.internation_information',{defaultValue:'头程信息'})" theme="info">
            <!-- <vForm inline class="margin-top-15 margin-right-15" :model="formData.packages" :labelWidth="107">
                <vFormItem class="width-100per" :label="$t('erp.product.carton_dimensions',{defaultValue:'外箱尺寸'})" prop="packedLength" :rules="type == 'query' ? '' : required">
                    <div style="display: flex;">
                        <Poptip trigger="hover" word-wrap :content="$t('erp.product.carton_dimensions_tip')">
                            <Icon style="margin-left: -5px; margin-right: 5px; cursor: pointer;" class="color-primary" size="12" type="md-help-circle" />
                        </Poptip>
                        <div v-if="type == 'query'" class="font-bold" style="display: inline">
                            {{(formData.packages.packedLength?formData.packages.packedLength:'--')+" * "+(formData.packages.packedWidth?formData.packages.packedWidth:'--')+" * "+(formData.packages.packedHeight?formData.packages.packedHeight:'--') + " inch"}}
                        </div>
                        <div style="display: flex; flex: 1;" v-else>
                            <vInputNumber class="margin-right-15" style="width: 24%;" placeholder="Length" :min="0" v-model="formData.packages.packedLength" @on-blur="handleNumberValue"></vInputNumber>
                            <vInputNumber class="margin-right-15" style="width: 24%;" placeholder="Width" :min="0" v-model="formData.packages.packedWidth" @on-blur="handleNumberValue"></vInputNumber>
                            <vInputNumber class="margin-right-15" style="width: 24%;" placeholder="Height" :min="0" v-model="formData.packages.packedHeight" @on-blur="handleNumberValue"></vInputNumber>
                            <vSelect style="flex: 1;" v-model="formData.packages.danwei3" @on-change="handleDanWei3Change" :filterable="true">
                                <vOption :value="0">cm</vOption>
                                <vOption :value="1">inch</vOption>
                            </vSelect>
                        </div>
                    </div>
                </vFormItem>
                <vFormItem class="width-50per" :label="$t('erp.product.carton_volume',{defaultValue:'外箱体积'})" prop="packedVolume">
                    <div style="display: flex;">
                        <Poptip trigger="hover" word-wrap :content="$t('erp.product.carton_volume_tip')">
                            <Icon style="margin-left: -5px; margin-right: 5px; cursor: pointer;" class="color-primary" size="12" type="md-help-circle" />
                        </Poptip>
                        <div v-if="type == 'query'" class="font-bold" style="display: inline">
                            {{formData.packages.packedVolume?formData.packages.packedVolume:'--'+ " inch3"}}
                        </div>
                        <div style="display: flex; flex: 1;" v-else>
                            <vInput v-model="formData.packages.packedVolume" :readonly="true">
                                <span slot='append' class="padding-left-10 padding-right-10" style="display: inline-block; width: 140px;">inch3</span>
                            </vInput>
                        </div>
                    </div>
                </vFormItem>
                <vFormItem class="width-50per" :label="$t('erp.product.carton_weight',{defaultValue:'外箱毛重'})" prop="packedWeight" :rules="type == 'query' ? '' : required">
                    <div style="display: flex;">
                        <Poptip trigger="hover" word-wrap :content="$t('erp.product.carton_weight_tip')">
                            <Icon style="margin-left: -5px; margin-right: 5px; cursor: pointer;" class="color-primary" size="12" type="md-help-circle" />
                        </Poptip>
                        <div v-if="type == 'query'" class="font-bold" style="display: inline">
                            {{((formData.packages.packedWeight?formData.packages.packedWeight:'')+ " lb")}}
                        </div>
                        <div style="display: flex; flex: 1;" v-else>
                            <vInputNumber style="flex: 1;" class="margin-right-15" v-model="formData.packages.packedWeight" placeholder="Gross Weight" @on-blur="handleWeightValue"></vInputNumber>
                            <vSelect v-model="formData.packages.danwei4" style="width: 30%;" :filterable="true" @on-change="handleDanWei4Change">
                                <vOption :value="0">g</vOption>
                                <vOption :value="1">oz</vOption>
                                <vOption :value="2">lb</vOption>
                            </vSelect>
                        </div>
                    </div>
                </vFormItem>
            </vForm> -->
			<compFormQuery v-if="type=='query'" class="margin-top-15 margin-right-15" :formdata="getHeadInfo" :value="formData.packages" :labelWidth="120"></compFormQuery>
			<compFormEdit ref="packageform" v-else class="margin-top-15 margin-right-15" :formdata="getHeadInfo" v-model="formData.packages" :labelWidth="120"></compFormEdit>
		</compWrapper>

		<!-- <compWrapper v-if="purchaseInfo" :title="$t('erp.product.procure_information',{defaultValue:'采购信息'})" theme="success">
			<compFormQuery v-if="type=='query'" class="margin-top-15 margin-right-15" :formdata="getPurchase" :value="formData" :labelWidth="120"></compFormQuery>
			<compFormEdit ref="purchaseform" v-else class="margin-top-15 margin-right-15" :formdata="getPurchase" v-model="formData" :labelWidth="120"></compFormEdit>
		</compWrapper> -->

		<compWrapper v-if="customsInfo" :title="$t('erp.product.clear_information',{defaultValue:'清关信息'})" theme="warning">
			<compClear :clearformdata="cleardata" :alltype="type" ref="refcompclear" :compfobPrice="formData.fobPrice"></compClear>
		</compWrapper>

		<compWrapper v-if="pictureInfo" :title="$t('erp.product.image_information',{defaultValue:'图片信息'})" theme="error">
			<compImage :imageformdata="imagedata" :alltype="type" ref="refcompimage"></compImage>
		</compWrapper>

		<compWrapper v-if="otherInfo" :title="$t('global.common.other_information',{defaultValue:'其他信息'})" theme="info" >
			<compOther :otherformdata="otherdata" :alltype="type" ref="refcompother"></compOther>
		</compWrapper>

		<compWrapper :title="$t('global.common.operation_history',{defaultValue:'操作历史'})" theme="gray" v-if="type=='query'">

            <compLog :data="logList"></compLog>
        </compWrapper>

		<div class="text-right margin-bottom-30" v-if="type!='query'">
			.
		</div>

        <vLoading size="large" transfer :loading="loading"></vLoading>
		<!-- 添加modal -->
		<vModal
			class="hidefooter customerupload"
			v-model="operate.show"
			:title="operate.title"
			v-bind="operate"
		>
			<searchCategory @on-chosedata="chosecategory" @on-close="closemodal"></searchCategory>
			<footer slot="footer" v-show="false"></footer>
		</vModal>
        <vModal class="hidefooter" v-model="modalProps.show" :title="modalProps.title" v-bind="modalProps">
            <compSku :baseInfo="modalProps.baseInfo"></compSku>
            <footer slot="footer" v-show="false"></footer>
        </vModal>
    </div>
</template>

<script>

import { mapState, mapGetters } from "vuex";
import compClear from '../compclear';
import compImage from '../compimage';
import compOther from '../compother';
import compSku from './sku.vue';
// 清关信息弹框
import addClear from '../addclear';
// 搜索品类
import searchCategory from "../searchcategory/index";
import TableList from "@components/templates/tablelist";
// 数据
import dataMixin from "@/views/datamixin.js";

import {
	HttpGetProductsOne,
	HttpSaveProducts,
	HttpGetCategories,
    HttpGetProductSize,
    HttpGetComputCost,
    HttpGetOrgConfig
} from '@/service/products/allproducts'
import {
    HttpProductList
} from "@/service/boss/dictionary";
import {
    HttpSysOpLog
} from '@/service/boss/allot';
export default {
    props:['activeids','querytype'],
    mixins: [dataMixin],
    components: {
		compWrapper: () => import("@components/templates/wrapper"),
		compFormQuery: () => import("@components/templates/formquery"),
		compFormEdit: () => import("@components/templates/formedit"),
		compLog: () => import("@components/templates/log"),
		compClear,
		compImage,
		compOther,
		searchCategory,
        compSku,
        // TableList
    },
    data(){
        return {
            warehouseInfo:false,
            packageInfo:false,
            // purchaseInfo:false,
            customsInfo:false,
            pictureInfo:false,
            otherInfo:false,
            loading: false,
            type: this.$route.params.type,
            id: this.$route.query.id,
            formData: {
				orderOnlyShow:0,
				danwei1:1,
				staging1:1,
				danwei2:2,
				staging2:2,
				packages:{
					cartonPackedQty:1,
                    palletCartonQty:0,
					danwei3:1,
					staging3:1,
					danwei4:2,
                    staging4:2,
                    cartonMaterialType: 0
				},
				isSeasonal:0,
                isCalculateCost:1,
                isSignService:0,
                expirationControl:0,
				status:0,
				productType:1,
				unit:'Pcs',
                packingType:'REPACK',
				isInsurance:'N',
				expirationType:'1',
				prePackedQty:1,
                packingSizeType:1,
                minOrderQty:1,
                shapeType: 0,
                materialType: 0,
                shippingMethod:0,
                isMagnetism: 0,
                isLiquid: 0,
                isContainBattery: 0,
                isFragile: 0,
			},
			titleName:'',
			showquery :false,
			logList:[],
			cleardata:{},
			imagedata:{},
			otherdata:{},
			operate: {
				id: null,
				title: "",
				show: false,
				component: null
			},
			salesList:[
				{value:'Bag',label:this.$t('erp.product.unit_bag', { defaultValue: 'Bag-袋、包' })},
				{value:'Bar',label:this.$t('erp.product.unit_bar', { defaultValue: 'Bar-条' })},
				{value:'Bottle',label:this.$t('erp.product.unit_bottle', { defaultValue: 'Bottle-瓶' })},
				{value:'Box',label:this.$t('erp.product.unit_box', { defaultValue: 'Box-盒' })},
				{value:'Bundle',label:this.$t('erp.product.unit_bundle', { defaultValue: 'Bundle-捆' })},
				{value:'Carton',label:this.$t('erp.product.unit_carton', { defaultValue: 'Carton-箱' })},
				{value:'Dozen',label:this.$t('erp.product.unit_dozen', { defaultValue: 'Dozen-打' })},
				{value:'Ea',label:this.$t('erp.product.unit_ea', { defaultValue: 'Ea-个' })},
				{value:'Pair',label:this.$t('erp.product.unit_pair', { defaultValue: 'Pair-副' })},
				{value:'Pcs',label:this.$t('erp.product.unit_pcs', { defaultValue: 'Pcs-件' })},
				{value:'Piece',label:this.$t('erp.product.unit_piece', { defaultValue: 'Piece-只' })},
				{value:'Set',label:this.$t('erp.product.unit_set', { defaultValue: 'Set-台、套' })},
				{value:'Unit',label:this.$t('erp.product.unit_unit', { defaultValue: 'Unit-辆' })},
			],
			salesLocationList: [
				{value: 0,label:this.$t('erp.product.none', { defaultValue: '无' })},
				{value: 1,label:'NEW'},
				{value: 2,label:'Core'},
				{value: 3,label:'Normal'},
				{value: 5,label:'Discontinued-w/ Inventory'},
				{value: 6,label:'Discontinued-w/o Inventory'},
			],
			categoryList:[],
			sizeNumber:0,
            autoGenrate: false,
            modalProps: {
                show: false
            },
            required: [{
                required: true,
                message: this.$t("global.common.fill_requiredd",{defaultValue:'该信息不能为空,请填写'})
            }],
            productList: [],
            isShowBattery: false,
            isRequireBatteryWeight: false,
            isRequireLabelType: false
        }
    },
    created(){
        this.getProductList();
        if (this.type === 'add') {
            // 获取是否计算成本的默认值
            HttpGetComputCost().then(res => {
                if (res.message == '1') {
                    this.formData.isCalculateCost = 1
                }
                else {
                    this.formData.isCalculateCost = 0
                }
            }, err => {
                this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
            })
        }
        if (this.type !== 'query') {
            this.getOrgConfig();
        }
        this.warehouseInfo = this.handleAuth('erp.product.set');
        this.packageInfo = this.handleAuth('erp.product.package');
        // this.purchaseInfo = this.handleAuth('erp.product.purchase');
        this.customsInfo = this.handleAuth('erp.product.custom');
        this.pictureInfo = this.handleAuth('erp.product.set');
        this.otherInfo = this.handleAuth('erp.product.other');

        if(this.activeids){
            this.id = this.activeids
            this.type = this.querytype
        }else{
            this.id = this.id
            this.type = this.type
		}
		this.showquery = this.type == 'query' || this.type == 'edit'
		this.getDetail()
		if(this.type != 'query'){
			// 放入品类各个名称
			this.getCategory()
			// console.log(12345)
		}
    },
    computed:{
		...mapGetters('diction',['getNewProductList']),
        ...mapGetters('dictionary', ['getCountryList']),
        getBase(){
			let _this = this;
			// console.log(this.formData.categoryCode)
            return [
				// 1
                {
					show:this.type!='query',
					label: this.$t('erp.product.categoryname_eng',{defaultValue:'品名（英文）'}),
					key: "nameEn",
					tag: "vInput",
					span:12,
				},
				{
					show:this.type=='query',
					label: this.$t('erp.product.categoryname_eng',{defaultValue:'品名（英文）'}),
					key: "nameEn",
					tag: "vInput",
                    span:24,
					// formItem:{
					// 	style:"width:50%"
					// }
                },
                {
					label: this.$t('erp.product.category_name',{defaultValue:'品名（中文）'}),
					key: "name",
					tag: "vInput",
                },
				// 2
                {
					label: this.$t('global.common.line',{defaultValue:'项目'}),
					key: "lineId",
					tag: "vSelect",
					query: this.showquery,
					// options: this.getNewProductList.map((item) => {
					options: this.productList.map((item) => {
						return {
							value: item.value,
							label: item.label
						}
					}),
					props: {
						filterable: true,
					},
					// on:{
					// 	'on-change':(data)=>{
					// 		let obj = _this.getNewProductList.filter(item=>{
					// 			return item.id == data
					// 		})
					// 		_this.changeErpsku(obj)
					// 	}
					// }
                },
                {
					label: "ERPSKU",
					key: "erpSku",
					tag: "vInput",
					query: this.showquery,
                    required: !this.autoGenrate,
                    props: {
                        disabled: this.autoGenrate,
                        placeholder: this.$t('erp.product.erpsku_number',{defaultValue:'只允许字母、数字、下划线，横杠，3-50位字符'})
                    },
					formItem:{
						tip: this.type=='query' ? '' : '<div class="color-error">'+this.$t('erp.product.erpsku_tip',{defaultValue:'只允许字母、数字、下划线，横杠，3-50位字符'})+'</div>',
					},
                },
                {
                    label: this.$t('erp.product.customise_product_code', { defaultValue: '自定义产品编码' }),
                    key: "erpSkuCode",
                    tag: 'vInput',
                    required: false,
                },
				// 3
				{
					label: this.$t('erp.product.factory_code',{defaultValue:'工厂编码'}),
					key: "factoryCode",
					tag: "vInput",
					required: false,
				},
                {
					label: this.$t('erp.product.category',{defaultValue:'品类'}),
					key: "categoryCode",
					required: false,
                    show:this.type!='query',
					children: (h) => {
						return <vIcon
							title={this.$t('erp.product.search_category',{defaultValue:'搜索品类'})}
							type="search"
							center
							slot="suffix"
							style="padding:6px;pointer-events: initial;"
							size="18"
							nativeOnClick={this.handleModalplat.bind(this)}
						/>
					},
					props: {
                        readonly: true,
                        placeholder:this.$t('erp.product.select_category',{defaultValue:'请选择品类'})
					}
                },
                {
                    label: this.$t('erp.product.category',{defaultValue:'品类'}),
					key: "categoryCode",
                    show:this.type=='query',
                    span:24,
                },
				// 单独品类
				{
					span:24,
					show:this.formData.categoryCode !='' && this.formData.categoryCode !=null && this.formData.categoryCode !=undefined && this.type!='query',
					valueText:this.titleName,
					query:true,
				},
				{
					span:24,
					show:this.type=='query',
					valueText:this.formData.codeName,
					query:true,
				},
				// 4
                {
					label: this.$t('erp.product.is_seasonal',{defaultValue:'是否季节性'}),
					key: "isSeasonal",
					tag: "vRadio",
					show: this.type != 'query',
					valueText: this.formData.isSeasonal == 1 ? this.$t('erp.global.yes',{defaultValue:'是'}) : this.$t('erp.global.no',{defaultValue:'否'}),
					props: {
						strict: false,
					},
					options: [{
						trueValue: 1,
						label: this.$t('erp.global.yes',{defaultValue:'是'})
					}, {
						trueValue: 0,
						label: this.$t('erp.global.no',{defaultValue:'否'})
                    }],
                },
                {
					label: this.$t('erp.product.is_seasonal',{defaultValue:'是否季节性'}),
					key: "isSeasonal",
					show: this.type == 'query',
					valueText: this.formData.isSeasonal == 1 ? this.$t('erp.global.yes',{defaultValue:'是'}) : this.$t('erp.global.no',{defaultValue:'否'})
				},
				// 季节性周期
				{
					label: this.$t('erp.product.season_cycle',{defaultValue:'季节性销售周期'}),
					span:12,
					query:true,
					valueText:this.formData.seasonalSalesCycle1+ this.$t('global.common.month',{defaultValue:' 月'}) +" ~ "+this.formData.seasonalSalesCycle2+ this.$t('global.common.month',{defaultValue:' 月'}),
					show:this.type =='query' && this.formData.seasonalSalesCycle1!=undefined
				},
                {
                    label: this.$t('erp.product.season_cycle',{defaultValue:'季节性销售周期'}),
                    tag: 'vInputNumber',
					key: 'seasonalSalesCycle1',
					show:this.formData.isSeasonal == 1 && this.type !='query',
					span:7,
					required:false,
					props:{
						min:1,
						max:12
					},
					children(h) {
						return <span slot='append' class="padding-left-10 padding-right-10">{this.$t('global.common.month',{defaultValue:' 月'})}</span>
					},
				},
				{
                    labelWidth: 0,
					tag: 'vInputNumber',
					key: 'seasonalSalesCycle2',
					show:this.formData.isSeasonal == 1 && this.type !='query',
					required:false,
					span:5,
					props:{
						min:1,
						max:12
					},
					children(h) {
						return <span slot='append' class="padding-left-10 padding-right-10">月</span>
					},
                },
				//5
                {
					label: this.$t('erp.product.pruchas_status',{defaultValue:'补货状态'}),
					key: "status",
					tag: "Select",
					options: [
                        {value:0, label:this.$t('erp.product.replenishment',{defaultValue:'正常补货'})},
                        {value:1, label:this.$t('erp.product.no_replenishment',{defaultValue:'不再补货'})}
                    ],
					props: {
						filterable: true,
					},
					formItem:{
						tip: this.type=='query' ? '' : '<div class="color-error">'+this.$t('erp.product.purchas_tip',{defaultValue:'采购员参考该字段制作补货计划'})+'</div>',
					}
                },
                {
					label: "EAN",
					key: "ean",
					tag: "Input",
					required: false,
					formItem:{
						tip: this.type=='query' ? '' : '<div class="color-error">'+this.$t('erp.product.EAM_tip',{defaultValue:'EAN码是国际物品编码协会制定的一种商品用条码，通用于全世界'})+'</div>',
					}
                },
				// 6
                {
					label: this.$t('erp.product.brand',{defaultValue:'品牌'}),
					key: "brand",
					tag: "vInput",
					required: false,
                },
                {
					label: "UPC",
					key: "upc",
					tag: "vInput",
					required: false,
                },
				// 7
                {
					label: this.$t('erp.product.product_type',{defaultValue:'产品类型'}),
					key: "productType",
					tag: "Select",
					options: [
                        {value:1, label:this.$t('erp.product.finish_goods',{defaultValue:'成品'})},
                        {value:2, label:this.$t('erp.product.accessories',{defaultValue:'配件'})},
                        {value:3, label:this.$t('erp.product.consumables',{defaultValue:'耗材'})}
                    ],
					props: {
						filterable: true,
					}
                },
                {
					label: this.$t('erp.product.min_salesunit',{defaultValue:'最小销售单位'}),
					key: "unit",
					tag: "Select",
					options: this.salesList,
					props: {
						filterable: true,
					}
                },
				// 8
                {
					label: this.$t('erp.product.calculate_cost',{defaultValue:'是否计算成本'}),
					key: "isCalculateCost",
					tag: "vRadio",
					show: this.type != 'query',
					valueText: this.formData.isCalculateCost == 1 ? this.$t('erp.global.yes',{defaultValue:'是'}) : this.$t('erp.global.no',{defaultValue:'否'}),
					props: {
						strict: false,
					},
					options: [{
						trueValue: 1,
						label: this.$t('erp.global.yes',{defaultValue:'是'})
					}, {
						trueValue: 0,
						label: this.$t('erp.global.no',{defaultValue:'否'})
					}],
                },
                {
					label: this.$t('erp.product.calculate_cost',{defaultValue:'是否计算成本'}),
					key: "isCalculateCost",
					show: this.type == 'query',
					valueText: this.formData.isCalculateCost == 1 ? this.$t('erp.global.yes',{defaultValue:'是'}) : this.$t('erp.global.no',{defaultValue:'否'})
                },
                {
					label: "FOB(USD)",
					key: "fobPrice",
					tag: "vInput",
					query:this.type != 'add',
					required:false,

				},
				{
					label: this.$t('erp.product.saleslocation',{defaultValue:'销售定位'}),
					key: "saleLocation",
					tag: "vSelect",
					required: false,
					options: this.salesLocationList,
					props: {
						filterable: true,
					}
                },
                // 新增编辑
                {
                    label: this.$t("erp.setting.country_of_origin", { defaultValue: "原产地" }),
                    key: "countryOfOrigin",
                    span: 12,
                    tag: "vSelect",
                    required: false,
                    options: this.getCountryList,
                    props: {
                        filterable: true,
                    },
                    query: this.type == 'query',
                    show: this.type != 'query'
                },
				{
					label: "",
                    tag: "div",
                    span:24,
					query: this.type !=' query',
					formItem:{
						style:'min-height:5px !important; margin-bottom:0px !important'
					}
                },
				// 9
				{
					label: this.$t('erp.product.package_dimension',{defaultValue:'单品外包装尺寸'}),
					span:12,
					query:true,
					valueText:(this.formData.length?this.formData.length:'--')+" * "+(this.formData.width?this.formData.width:'--')+" * "+(this.formData.height?this.formData.height:'--') + " inch",
					show:this.type =='query'
				},
                {
					label: this.$t('erp.product.package_dimension',{defaultValue:'单品外包装尺寸'}),
                    key: "length",
                    span:7,
					tag: "vInputNumber",
                    style:"padding-right:20px",
                    props:{
						placeholder:"Length",
					},
					on:{
						'on-blur':(value)=>{
							if(value>10000000){
								this.$VMessage.error(this.$t('erp.product.length_bigmorethan',{defaultValue:'长度不能超过 10000000'}))
							}
						}
					},
					show:this.type !='query'
                },
                {
                    labelWidth:0,
                    key: "width",
                    span:5,
					tag: "vInputNumber",
                    style:"padding-right:20px",
                    props:{
                        placeholder:"Width",
					},
					on:{
						'on-blur':(value)=>{
							if(value>10000000){
								this.$VMessage.error(this.$t('erp.product.width_bigmorethan',{defaultValue:'宽度不能超过 10000000'}))
							}
						}
					},
					show:this.type !='query'
                },
                {
                    labelWidth:0,
                    key: "height",
                    span:5,
					tag: "vInputNumber",
                    style:"padding-right:20px",
                    props:{
						placeholder:"Height",
					},
					on:{
						'on-blur':(value)=>{
							if(value>10000000){
								this.$VMessage.error(this.$t('erp.product.height_bigmorethan',{defaultValue:'高度不能超过 10000000'}))
							}
						}
					},
					show:this.type !='query'
                },
                {
					labelWidth:0,
					key: "danwei1",
                    tag: "vSelect",
                    span:5,
					options: [
                        {value:0, label:'cm'},
                        {value:1, label:'inch'},
					],
					on:{
						'on-change':function(value){
							if(_this.formData.staging1 == 1 && _this.formData.danwei1 == 0){
								_this.formData.staging1 = 0;

								_this.formData.length = _this.getNumberfun(_this.formData.length,'nultiplicate',1)
								_this.formData.width = _this.getNumberfun(_this.formData.width,'nultiplicate',1)
								_this.formData.height = _this.getNumberfun(_this.formData.height,'nultiplicate',1)

							}else if(_this.formData.staging1 == 0 && _this.formData.danwei1 == 1){
								_this.formData.staging1 = 1;

								_this.formData.length = _this.getNumberfun(_this.formData.length,'division',5)
								_this.formData.width = _this.getNumberfun(_this.formData.width,'division',5)
								_this.formData.height = _this.getNumberfun(_this.formData.height,'division',5)
							}
							// console.log(oldvaue,newvalue)
						}
					},
					props: {
						filterable: true,
					},
					show:this.type !='query'
				},
				// 10
				{
					label: this.$t('erp.product.gorss_weight',{defaultValue:'产品毛重'}),
					span:12,
					query:true,
					valueText:(this.formData.weight?this.formData.weight:'--')+ " lb",
					show:this.type =='query'
				},
				{
					label: this.$t('erp.product.gorss_weight',{defaultValue:'产品毛重'}),
                    key: "weight",
                    span:8,
					tag: "vInputNumber",
                    style:"padding-right:20px",
                    props:{
                        placeholder:"Weight"
					},
					on:{
						'on-blur':(value)=>{
							if(value>10000000){
								this.$VMessage.error(this.$t('erp.product.weight_bigmorethan',{defaultValue:'产品毛重不能超过 10000000'}))
							}
						}
					},
					show:this.type !='query'
				},
                {
					labelWidth:0,
					key: "danwei2",
                    tag: "vSelect",
					span:5,
					style:"padding-right:20px",
					options: [
                        {value:0, label:'g'},
						{value:1, label:'oz'},
						{value:2, label:'lb'},
					],
					on:{
						'on-change':function(value){
							// g->oz oz->g
							if(_this.formData.staging2 == 1 && _this.formData.danwei2 == 0){
								_this.formData.staging2 = 0;
								_this.formData.weight = _this.getNumberfun(_this.formData.weight,'nultiplicate',2)

							}else if(_this.formData.staging2 == 0 && _this.formData.danwei2 == 1){
								_this.formData.staging2 = 1;
								_this.formData.weight = _this.getNumberfun(_this.formData.weight,'division',6)

							//oz->lb lb->oz
							}else if(_this.formData.staging2 == 1 && _this.formData.danwei2 == 2){
								_this.formData.staging2 = 2;
								_this.formData.weight = _this.getNumberfun(_this.formData.weight,'division',7)

							}else if(_this.formData.staging2 == 2 && _this.formData.danwei2 == 1){
								_this.formData.staging2 = 1;
								_this.formData.weight = _this.getNumberfun(_this.formData.weight,'nultiplicate',3)

							// g->lb lb->g
							}else if(_this.formData.staging2 == 0 && _this.formData.danwei2 == 2){
								_this.formData.staging2 = 2;
								_this.formData.weight = _this.getNumberfun(_this.formData.weight,'division',8)

							}else if(_this.formData.staging2 == 2 && _this.formData.danwei2 == 0){
								_this.formData.staging2 = 0;
								_this.formData.weight = _this.getNumberfun(_this.formData.weight,'nultiplicate',4)

							}

							// console.log(oldvaue,newvalue)
						}
					},
					props: {
						filterable: true,
					},
					show:this.type !='query'
				},
                // 查看
				{
                    label: this.$t("erp.setting.country_of_origin", { defaultValue: "原产地" }),
                    key: "countryOfOrigin",
                    span: 12,
                    tag: "vSelect",
                    required: false,
                    options: this.getCountryList,
                    props: {
                        filterable: true,
                    },
                    query: false,
                    show: this.type == 'query'
                },

            ]
		},
		getWarehouse(){
			return [
				// 1
				{
					label: this.$t('erp.product.repack_ornot',{defaultValue:'运输包装方式'}),
					key: "packingType",
                    tag: "Select",
                    options: [
                        {value:'REPACK', label:'PACKAGE'},
                        {value:'ORIGINAL', label:'ORIGINAL'},
                    ],
                    props: {
                        filterable: true,
                    },
					formItem:{
						tip: this.type=='query' ? '' : '<div class="color-error">（'+this.$t('erp.product.repack_tip',{defaultValue:'加运输包装即需要repack'})+'）</div>',
					}
                },
                {
                    label: this.$t("erp.product.packing_shape", {
                                defaultValue: "包装形状",
                            }),
                    key: 'shapeType',
                    tag: 'Select',
                    options: [{
                        value: 0,
                        label: this.$t("erp.product.cuboid", {
                                defaultValue: "长方体",
                            })
                    }, {
                        value: 1,
                        label: this.$t("erp.product.differentform", {
                                defaultValue: "异形体",
                            })
                    }]
                },
                {
                    label: this.$t("erp.product.packing_material", {
                                defaultValue: "包装材质",
                            }),
                    key: 'materialType',
                    tag: 'Select',
                    options: [{
                        value: 0,
                        label: this.$t("erp.product.cartons", {
                                defaultValue: "纸箱",
                            })
                    }, {
                        value: 1,
                        label: this.$t("bi.work.task_category_other", {
                                defaultValue: "其他",
                            })
                    }]
                },
                // 7
				{
					label: this.$t('erp.product.package_qty',{defaultValue:'单包装销售件数'}),
					key: "prePackedQty",
					required:false,
					tag: "Input",
					formItem:{
						tip: this.type=='query' ? '' : '<div class="color-error">（'+this.$t('erp.product.packageqty_tip',{defaultValue:'最小配送单位内的商品数量，即消费者收到的最小包装、邮购单位'})+'）</div>',
					}
                },
                {
                    show:global.SYSID == '1000147',
                    label: 'shippingMethod',
                    key: 'shippingMethod',
                    tag: 'Select',
                    options: [{
                        value: 0,
                        label: this.$t('fbb.accountmanage.express',{defaultValue:'快递'})
                    }, {
                        value: 1,
                        label: this.$t('fbb.inbound.truck',{defaultValue:'卡车'})
                    }],
                },
                {
                    label: this.$t("erp.product.ismagnetic", {
                                defaultValue: "是否带磁",
                            }),
                    key: 'isMagnetism',
                    tag: 'vRadio',
                    options: [{
						trueValue: 1,
						label: this.$t('erp.global.yes',{defaultValue:'是'})
					}, {
						trueValue: 0,
						label: this.$t('erp.global.no',{defaultValue:'否'})
                    }],
                    valueText: this.formData.isMagnetism == 1 ? this.$t('erp.global.yes',{defaultValue:'是'}) : this.$t('erp.global.no',{defaultValue:'否'}),
					props: {
						strict: false,
                    },
                },
                {
                    label: this.$t("erp.product.isliquid", {
                                defaultValue: "是否含液体",
                            }),
                    key: 'isLiquid',
                    tag: 'vRadio',
                    options: [{
						trueValue: 1,
						label: this.$t('erp.global.yes',{defaultValue:'是'})
					}, {
						trueValue: 0,
						label: this.$t('erp.global.no',{defaultValue:'否'})
                    }],
                    valueText: this.formData.isLiquid == 1 ? this.$t('erp.global.yes',{defaultValue:'是'}) : this.$t('erp.global.no',{defaultValue:'否'}),
					props: {
						strict: false,
                    },
                },
                {
                    label: this.$t("erp.product.isbattery", {
                                defaultValue: "是否含电池",
                            }),
                    key: 'isContainBattery',
                    tag: 'vRadio',
                    options: [{
						trueValue: 1,
						label: this.$t('erp.global.yes',{defaultValue:'是'})
					}, {
						trueValue: 0,
						label: this.$t('erp.global.no',{defaultValue:'否'})
                    }],
                    valueText: this.formData.isContainBattery == 1 ? this.$t('erp.global.yes',{defaultValue:'是'}) : this.$t('erp.global.no',{defaultValue:'否'}),
					props: {
						strict: false,
                    },
                    on: {
                        "on-change": (val) => {
                            this.isShowBattery = !!val;
                            // 选中含电池时，给电池标默认否
                            if (val == 1) {
                                this.$set(this.formData, "batteryLabel", 0);
                            }
                            else {
                                delete this.formData.batteryLabel;
                            }
                        }
                    }
                },
                {
                    label: this.$t('erp.product.battery_power', { defaultValue: "电池功率" }) + "(WH)",
                    key: "batteryPower",
                    tag: "vInputNumber",
                    show: this.isShowBattery
                },
                {
                    label: this.$t('erp.product.battery_type', { defaultValue: "电池类型" }),
                    key: "batteryType",
                    tag: "vSelect",
                    options: this.getBatteryType,
                    show: this.isShowBattery
                },
                {
                    label: this.$t('erp.product.battery_package_type', { defaultValue: "电池包装方式" }),
                    key: "batteryPackageType",
                    tag: "vSelect",
                    options: this.getBatteryPackageType,
                    show: this.isShowBattery,
                    on: {
                        "on-change": (val) => {
                            // 选中 alone in box时，电池重量必填
                            this.isRequireBatteryWeight = val == 0;
                        }
                    },
                },
                {
                    label: this.$t('erp.product.battery_weight', { defaultValue: "电池重量" }) + "（lb）",
                    key: "batteryWeight",
                    tag: "vInputNumber",
                    show: this.isShowBattery,
                    render: (h) => {
                        if (!this.formData.batteryWeight) return "--";
                        return this.formData.batteryWeight;
                    },
                    required: this.isRequireBatteryWeight
                },
                {
                    label: this.$t('erp.product.battery_label', { defaultValue: "是否已经张贴电池标" }),
                    key: "batteryLabel",
                    tag: "vRadio",
                    options: this.getIsBatteryLabel,
                    show: this.isShowBattery,
                    on: {
                        "on-change": (val) => {
                            this.isRequireLabelType = val == 1;
                        }
                    },
                },
                {
                    label: this.$t('erp.product.battery_label_type', { defaultValue: "电池标类型" }),
                    key: "batteryLabelType",
                    tag: "vSelect",
                    options: this.getBatteryLabelType,
                    required: this.isRequireLabelType,
                    show: this.isShowBattery,
                },
                {
                    label: this.$t("erp.product.isfragile", {
                                defaultValue: "是否易碎",
                            }),
                    key: 'isFragile',
                    tag: 'vRadio',
                    options: [{
						trueValue: 1,
						label: this.$t('erp.global.yes',{defaultValue:'是'})
					}, {
						trueValue: 0,
						label: this.$t('erp.global.no',{defaultValue:'否'})
                    }],
                    valueText: this.formData.isFragile == 1 ? this.$t('erp.global.yes',{defaultValue:'是'}) : this.$t('erp.global.no',{defaultValue:'否'}),
					props: {
						strict: false,
                    },
                },
				{
					label: this.$t('erp.product.is_signature',{defaultValue:'是否需要签收服务'}),
					key: "isSignService",
					tag: "vRadio",
					show: this.type != 'query',
					valueText: this.formData.isSignService == 1 ? this.$t('erp.global.yes',{defaultValue:'是'}) : this.$t('erp.global.no',{defaultValue:'否'}),
					props: {
						strict: false,
					},
					options: [{
						trueValue: 1,
						label: this.$t('erp.global.yes',{defaultValue:'是'})
					}, {
						trueValue: 0,
						label: this.$t('erp.global.no',{defaultValue:'否'})
					}],
					formItem:{
						tip: this.type=='query' ? '' : '<div class="color-error">（'+this.$t('erp.product.signature_tip',{defaultValue:'签收服务的资费请咨询客服'})+'）</div>',
					}
                },
                {
					label: this.$t('erp.product.is_signature',{defaultValue:'是否需要签收服务'}),
					key: "isSignService",
					show: this.type == 'query',
					valueText: this.formData.isSignService == 1 ? this.$t('erp.global.yes',{defaultValue:'是'}) : this.$t('erp.global.no',{defaultValue:'否'})
				},
				// 3
				{
					label: this.$t('erp.product.express_valuation',{defaultValue:'快递保价'}),
					key: "isInsurance",
					tag: "vRadio",
					show: this.type != 'query',
					valueText: this.formData.isInsurance == 'Y' ? this.$t('erp.global.yes',{defaultValue:'是'}) : this.$t('erp.global.no',{defaultValue:'否'}),
					props: {
						strict: false,
					},
					options: [{
						trueValue: 'Y',
						label: this.$t('erp.global.yes',{defaultValue:'是'})
					}, {
						trueValue: 'N',
						label: this.$t('erp.global.no',{defaultValue:'否'})
					}],
					formItem:{
						tip: this.type=='query' ? '' : '<div class="color-error">（'+this.$t('erp.product.express_tip',{defaultValue:'必须符合FedEx承运范围，具体资费咨询客服'})+'）</div>',
					}
                },
                {
					label: this.$t('erp.product.express_valuation',{defaultValue:'快递保价'}),
					key: "isInsurance",
					show: this.type == 'query',
					valueText: this.formData.isInsurance == 'Y' ? this.$t('erp.global.yes',{defaultValue:'是'}) : this.$t('erp.global.no',{defaultValue:'否'})
				},
				// 4
				{
					label: this.$t('erp.product.insured_price',{defaultValue:'投保金额（USD）'}),
					key: "insuranceRate",
					tag: "vInputNumber",
					// show:this.formData.isInsurance=='Y',
                    show: true,
					props:{
						min: 0,
					},
                    required: this.formData.isInsurance == 'Y'
					// formItem:{
					// 	tip: this.type=='query' ? '' : '<div class="color-error">（总货值=FOB*（1+货值上浮率））</div>',
					// }
				},
				// 5
				{
					label: this.$t('erp.product.shelf_control',{defaultValue:'保质期控制'}),
					key: "expirationControl",
					tag: "vRadio",
					required:false,
					show: this.type != 'query' && global.SYSID==49,
					valueText: this.formData.expirationControl == 1 ? this.$t('erp.global.yes',{defaultValue:'是'}) : this.$t('erp.global.no',{defaultValue:'否'}),
					props: {
						strict: false,
					},
					options: [{
						trueValue: 1,
						label: this.$t('erp.global.yes',{defaultValue:'是'})
					}, {
						trueValue: 0,
						label:this.$t('erp.global.no',{defaultValue:'否'})
					}],
                },
                {
					label: this.$t('erp.product.shelf_control',{defaultValue:'保质期控制'}),
					key: "expirationControl",
					show: this.type == 'query' && global.SYSID==49,
					valueText: this.formData.expirationControl == 1 ? this.$t('erp.global.yes',{defaultValue:'是'}) : this.$t('erp.global.no',{defaultValue:'否'})
				},
				// 6
				{
					label:this.$t('erp.product.shelf_life',{defaultValue:'保质期'}),
					span:12,
					query:true,
					valueText:this.formData.expirationDate + this.filterData(this.formData.expirationType),
					show:this.type =='query' && global.SYSID==49
				},
				{
					label: this.$t('erp.product.shelf_life',{defaultValue:'保质期'}),
					show:this.formData.expirationControl == 1 && this.type !='query' && global.SYSID==49,
					required:false,
					key: "expirationDate",
					tag: "vInput",
					span:8,
				},
				{
					labelWidth:0,
					show:this.formData.expirationControl == 1 && this.type !='query' && global.SYSID==49,
					key: "expirationType",
                    tag: "vSelect",
					span:4,
					style:"padding-right:20px",
					query: this.showquery,
					options: [
                        {value:'1', label:this.$t('global.common.day',{defaultValue:'日'})},
						{value:'2', label:this.$t('global.common.week',{defaultValue:'周'})},
						{value:'0', label:this.$t('global.common.month',{defaultValue:'月'})},
                    ],
					props: {
						filterable: true,
					}
				},

			]
		},
		getHeadInfo(){
			let _this = this;
			return [
				// 1
				{
					label: this.$t('erp.product.carton_dimensions',{defaultValue:'外箱尺寸'}),
					span:12,
					query:true,
					valueText:(this.formData.packages.packedLength?this.formData.packages.packedLength:'--')+" * "+(this.formData.packages.packedWidth?this.formData.packages.packedWidth:'--')+" * "+(this.formData.packages.packedHeight?this.formData.packages.packedHeight:'--') + " inch",
					show:this.type =='query'
				},
				// 编辑，添加的时候展示
				{
					show: this.type != 'query',
					label: this.$t('erp.product.carton_dimensions',{defaultValue:'外箱尺寸'}),
					key: "packedLength",
                    span:7,
					tag: "vInputNumber",
					style:"padding-right:20px",
					on:{
						'on-blur':(value)=>{
							if(value>10000000){
								this.$VMessage.error(this.$t('erp.product.length_bigmorethan',{defaultValue:'长度不能超过 10000000'}))
							}
						}
					},
                    props:{
						placeholder:"Length",
						min:0,
                    }
				},
                {
					show: this.type != 'query',
                    labelWidth:0,
                    key: "packedWidth",
                    span:5,
					tag: "vInputNumber",
					style:"padding-right:20px",
					on:{
						'on-blur':(value)=>{
							if(value>10000000){
								this.$VMessage.error(this.$t('erp.product.width_bigmorethan',{defaultValue:'宽度不能超过 10000000'}))
							}
						}
					},
                    props:{
                        placeholder:"Width",
						min:0,
                    }
                },
                {
					show: this.type != 'query',
                    labelWidth:0,
                    key: "packedHeight",
                    span:5,
					tag: "vInputNumber",
					style:"padding-right:20px",
					on:{
						'on-blur':(value)=>{
							if(value>10000000){
								this.$VMessage.error(this.$t('erp.product.height_bigmorethan',{defaultValue:'高度不能超过 10000000'}))
							}
						}
					},
                    props:{
						placeholder:"Height",
						min:0,
                    }
                },
                {
					show: this.type != 'query',
					labelWidth:0,
					key: "danwei3",
                    tag: "vSelect",
                    span:5,
					options: [
                        {value:0, label:'cm'},
                        {value:1, label:'inch'},
					],
					on:{
						'on-change':function(value){
							// console.log(value,_this.formData.length)
							// console.log(_this.formData.staging3,_this.formData.danwei1)
							if(_this.formData.packages.staging3 == 1 && _this.formData.packages.danwei3 == 0){
								_this.formData.packages.staging3 = 0;

								_this.formData.packages.packedLength = _this.getNumberfun(_this.formData.packages.packedLength,'nultiplicate',1)
								_this.formData.packages.packedWidth = _this.getNumberfun(_this.formData.packages.packedWidth,'nultiplicate',1)
								_this.formData.packages.packedHeight = _this.getNumberfun(_this.formData.packages.packedHeight,'nultiplicate',1)


							}else if(_this.formData.packages.staging3 == 0 && _this.formData.packages.danwei3 == 1){
								_this.formData.packages.staging3 = 1;

								_this.formData.packages.packedLength = _this.getNumberfun(_this.formData.packages.packedLength,'division',5)
								_this.formData.packages.packedWidth = _this.getNumberfun(_this.formData.packages.packedWidth,'division',5)
								_this.formData.packages.packedHeight = _this.getNumberfun(_this.formData.packages.packedHeight,'division',5)

							}
							// console.log(oldvaue,newvalue)
						}
					},
					props: {
						filterable: true,
					}
				},
				{
					label: "",
                    tag: "div",
                    span:24,
					query: this.type !=' query',
					formItem:{
						style:'min-height:5px !important; margin-bottom:0px !important'
					}
                },
				// 2
				{
					label: this.$t('erp.product.carton_volume',{defaultValue:'外箱体积'}),
					span:12,
					query:true,
					valueText:this.formData.packages.packedVolume?this.formData.packages.packedVolume:'--'+ " inch3",
					show:this.type =='query'
				},
				{
					label: this.$t('erp.product.carton_volume',{defaultValue:'外箱体积'}),
					key: "packedVolume",
					tag:'vInput',
					children(h) {
						return <span slot='append' class="padding-left-10 padding-right-10">inch3</span>
					},
					props:{
						readonly:true
					},
					required:false,
					show:this.type!='query'
				},
				// 3
				{
					label: this.$t('erp.product.carton_weight',{defaultValue:'外箱毛重'}),
					span:12,
					query:true,
					valueText:(this.formData.packages.packedWeight?this.formData.packages.packedWeight:'')+ " lb",
					show:this.type =='query'
				},
				{
					show:this.type !='query',
					label: this.$t('erp.product.carton_weight',{defaultValue:'外箱毛重'}),
					key: "packedWeight",
					tag: "vInputNumber",
					span:8,
					on:{
						'on-blur':(value)=>{
							if(value>10000000){
								this.$VMessage.error(this.$t('erp.product.cartonweight_bigmorethan',{defaultValue:'外箱毛重不能超过 10000000'}))
							}
						}
					},
					props:{
						placeholder:"Gross Weight"
					}
				},
				{
					show:this.type !='query',
					labelWidth:0,
					key: "danwei4",
                    tag: "vSelect",
                    span:4,
					options: [
                        {value:0, label:'g'},
						{value:1, label:'oz'},
						{value:2, label:'lb'},
					],
					on:{
						'on-change':function(value){
							// console.log(value,_this.formData.length)
							// console.log(_this.formData.staging4,_this.formData.danwei1)
							if(_this.formData.packages.staging4 == 1 && _this.formData.packages.danwei4 == 0){
								_this.formData.packages.staging4 = 0;
								_this.formData.packages.packedWeight = _this.getNumberfun(_this.formData.packages.packedWeight,'nultiplicate',2)

							}else if(_this.formData.packages.staging4 == 0 && _this.formData.packages.danwei4 == 1){
								_this.formData.packages.staging4 = 1;
								_this.formData.packages.packedWeight = _this.getNumberfun(_this.formData.packages.packedWeight,'division',6)

							}else if(_this.formData.packages.staging4 == 1 && _this.formData.packages.danwei4 == 2){
								_this.formData.packages.staging4 = 2;
								_this.formData.packages.packedWeight = _this.getNumberfun(_this.formData.packages.packedWeight,'division',7)

							}else if(_this.formData.packages.staging4 == 2 && _this.formData.packages.danwei4 == 1){
								_this.formData.packages.staging4 = 1;
								_this.formData.packages.packedWeight = _this.getNumberfun(_this.formData.packages.packedWeight,'nultiplicate',3)

							}else if(_this.formData.packages.staging4 == 0 && _this.formData.packages.danwei4 == 2){
								_this.formData.packages.staging4 = 2;
								_this.formData.packages.packedWeight = _this.getNumberfun(_this.formData.packages.packedWeight,'division',8)

							}else if(_this.formData.packages.staging4 == 2 && _this.formData.packages.danwei4 == 0){
								_this.formData.packages.staging4 = 0;
								_this.formData.packages.packedWeight = _this.getNumberfun(_this.formData.packages.packedWeight,'nultiplicate',4)

							}
							// console.log(oldvaue,newvalue)
						}
					},
					props: {
						filterable: true,
					}
				},
				// 4
				{
					label: this.$t('erp.product.carton_qty',{defaultValue:'装箱入数'}),
					tag:'vInput',
					key: "cartonPackedQty",
                    span:24,
                    query: this.type == 'query',
					formItem: {
						style: "width:50%"
					},
                },
                {
                    label: this.$t('erp.product.pallet_carton_qty',{defaultValue:'每托箱数'}),
                    tag:'vInput',
                    key: "palletCartonQty",
                    span:24,
                    query: this.type == 'query',
                    formItem: {
                        style: "width:50%"
                    },
                },
                {
                    label: this.$t("erp.product.carton_material_type", {
                                defaultValue: "外箱包装材质",
                            }),
                    tag: 'Select',
                    key: 'cartonMaterialType',
                    options: [{
                        value: 0,
                        label: this.$t("erp.product.cartons", {
                                defaultValue: "纸箱",
                            })
                    }, {
                        value: 1,
                        label: this.$t("bi.work.task_category_other", {
                                defaultValue: "其他",
                            })
                    }]
                },
                {
                    label: this.$t("erp.product.stacked_layers", {
                                defaultValue: "最高可堆叠层数",
                            }),
                    tag:'Input',
                    key: 'cartonMaxStacking',
                    required: false,
					formItem:{
						tip: this.type=='query' ? '' : `<div class="color-error">（${this.$t('erp.product.inbound_no_ask', { defaultValue: '仓库入库时会堆叠外箱，不填则表示无要求' })}）</div>`,
					}
                }
			]
		},
		getPurchase(){
			return [
				{
					label: this.$t('erp.product.product_leadtime',{defaultValue:'生产提前期(天)'}),
					key: "periodInAdvance",
					tag: "vInput",
				},
				{
					label: this.$t('erp.product.transport_leadtime',{defaultValue:'物流提前期(天)'}),
					key: "logisticsLeadTime",
					tag: "vInput",
				},
				{
					label: this.$t('erp.product.min_orderqty',{defaultValue:'最小起订量'}),
					key: "minOrderQty",
					tag: "vInput",
				},
				{
					label: this.$t('erp.product.replenishment_cycle',{defaultValue:'补货周期(天)'}),
					key: "replenishmentCycle",
					tag: "vInput",
				},
				{
					label: this.$t('erp.product.safety_days',{defaultValue:'安全库存天数'}),
					key: "safetyStockDays",
					tag: "vInput",
				},
			]
		}
	},
	watch:{
		"formData.packages.packedLength":function(){
			this.getPackedvolume(this.formData.packages.staging3)
		},
		"formData.packages.packedWidth":function(){
			this.getPackedvolume(this.formData.packages.staging3)
		},
		"formData.packages.packedHeight":function(){
			this.getPackedvolume(this.formData.packages.staging3)
        },
        $route (to, from) {
            this.id = this.$route.query.id
            this.getDetail()
            // location.reload()
        }
	},
    methods:{
        handleDanWei4Change (value) {
            if(this.formData.packages.staging4 == 1 && this.formData.packages.danwei4 == 0){
                this.formData.packages.staging4 = 0;
                this.formData.packages.packedWeight = this.getNumberfun(this.formData.packages.packedWeight,'nultiplicate',2)

            }else if(this.formData.packages.staging4 == 0 && this.formData.packages.danwei4 == 1){
                this.formData.packages.staging4 = 1;
                this.formData.packages.packedWeight = this.getNumberfun(this.formData.packages.packedWeight,'division',6)

            }else if(this.formData.packages.staging4 == 1 && this.formData.packages.danwei4 == 2){
                this.formData.packages.staging4 = 2;
                this.formData.packages.packedWeight = this.getNumberfun(this.formData.packages.packedWeight,'division',7)

            }else if(this.formData.packages.staging4 == 2 && this.formData.packages.danwei4 == 1){
                this.formData.packages.staging4 = 1;
                this.formData.packages.packedWeight = this.getNumberfun(this.formData.packages.packedWeight,'nultiplicate',3)

            }else if(this.formData.packages.staging4 == 0 && this.formData.packages.danwei4 == 2){
                this.formData.packages.staging4 = 2;
                this.formData.packages.packedWeight = this.getNumberfun(this.formData.packages.packedWeight,'division',8)

            }else if(this.formData.packages.staging4 == 2 && this.formData.packages.danwei4 == 0){
                this.formData.packages.staging4 = 0;
                this.formData.packages.packedWeight = this.getNumberfun(this.formData.packages.packedWeight,'nultiplicate',4)

            }
        },
        handleWeightValue (value) {
            if(value>10000000){
                this.$VMessage.error(this.$t('erp.product.cartonweight_bigmorethan',{defaultValue:'外箱毛重不能超过 10000000'}))
            }
        },
        handleDanWei3Change (value) {
            // console.log(value,_this.formData.length)
            // console.log(_this.formData.staging3,_this.formData.danwei1)
            if(this.formData.packages.staging3 == 1 && this.formData.packages.danwei3 == 0){
                this.formData.packages.staging3 = 0;

                this.formData.packages.packedLength = this.getNumberfun(this.formData.packages.packedLength,'nultiplicate',1)
                this.formData.packages.packedWidth = this.getNumberfun(this.formData.packages.packedWidth,'nultiplicate',1)
                this.formData.packages.packedHeight = this.getNumberfun(this.formData.packages.packedHeight,'nultiplicate',1)


            }else if(this.formData.packages.staging3 == 0 && this.formData.packages.danwei3 == 1){
                this.formData.packages.staging3 = 1;

                this.formData.packages.packedLength = this.getNumberfun(this.formData.packages.packedLength,'division',5)
                this.formData.packages.packedWidth = this.getNumberfun(this.formData.packages.packedWidth,'division',5)
                this.formData.packages.packedHeight = this.getNumberfun(this.formData.packages.packedHeight,'division',5)

            }
        },
        handleNumberValue (value) {
            if(value>10000000){
                this.$VMessage.error(this.$t('erp.product.height_bigmorethan',{defaultValue:'高度不能超过 10000000'}))
            }
        },
        getProductList () {
            HttpProductList().then(res => {
                this.productList = res.data.map(item => {
                    return {
                        value: item.id,
                        label: `${item.name}`,
                        attach: {
                            supplierId:item.supplierId,
                            paymentType:item.paymentType,
                            nickname:item.nickname
                        }
                    }
                });
            }, err => {
                this.$VMessage.error(err.message);
            });
        },
        downloadProduct () {
            this.modalProps = {
                title: this.$t('erp.product.download_product_flag', { defaultValue: '下载产品标' }),
                show: true,
                width: 850,
                baseInfo: this.formData
            }
        },
        // 获取组织配置
        async getOrgConfig () {
            await HttpGetOrgConfig({
                id: global.SYSID,
                hostId: -1,
                globalDefault: 1,
            }).then(res => {
                if (res.data && res.data.optionValue == 1) {
                    this.autoGenrate = true;
                    // this.$set(this.formData, 'erpSku', '根据组织配置，ERPSKU会自动生成');
                }
                else {
                    this.autoGenrate = false;
                }
            }, err => {
                this.$VMessage.error(err.message);
                this.autoGenrate = false;
            });
        },
		getNumberfun(value,type,num){
			// 乘法
			let data;
			if(type =='nultiplicate'){
				switch(num){
					case 1 : data = (Number(value || 0) * 2.54).toFixed(4); break;
					case 2 : data = (Number(value || 0) * 28.35).toFixed(4); break;
					case 3 : data = (Number(value || 0) * 16).toFixed(4); break;
					case 4 : data = (Number(value || 0) * 453.592).toFixed(4); break;
				}
			// 除法
			}else{
				switch(num){
					case 5 : data = (Number(value || 0) / 2.54).toFixed(4); break;
					case 6 : data = (Number(value || 0) / 28.35).toFixed(4); break;
					case 7 : data = (Number(value || 0) / 16).toFixed(4); break;
					case 8 : data = (Number(value || 0) / 453.592).toFixed(4); break;
				}
			}
			return data
		},
		filterData(value){
			if(value==0){
				return this.$t('global.common.month',{defaultValue:'月'})
			}else if(value==1){
				return this.$t('global.common.day',{defaultValue:'日'})
			}else{
				return this.$t('global.common.week',{defaultValue:'周'})
			}
		},
		getPackedvolume(value){
			if(value == 0){
				this.formData.packages.packedVolume = ((Number(this.formData.packages.packedLength)/2.54) * (Number(this.formData.packages.packedWidth)/2.54) * (Number(this.formData.packages.packedHeight)/2.54)).toFixed(4) || 0
			}else{
				this.formData.packages.packedVolume = (Number(this.formData.packages.packedLength) * Number(this.formData.packages.packedWidth) * Number(this.formData.packages.packedHeight)).toFixed(4) || 0
			}
		},
		changeErpsku(data){
			// console.log(data)
			let objName = data[0].projectUnicode

			this.formData.erpSku = objName+this.getDay()
		},
		getDay(){
            var today = new Date();
            // var targetday_milliseconds=today.getTime() + 1000*60*60*24*day;
            // today.setTime(targetday_milliseconds); //注意，这行是关键代码
            var tYear = today.getFullYear();
            var tMonth = today.getMonth();
			var tDate = today.getDate();
			var tHours = today.getHours();
			var tMinutes = today.getMinutes();
			var tSeconds = today.getSeconds();
            tMonth = this.doHandleMonth(tMonth + 1);
			tDate = this.doHandleMonth(tDate);
			tHours = this.doHandleMonth(tHours)
			tMinutes = this.doHandleMonth(tMinutes)
			tSeconds = this.doHandleMonth(tSeconds)
			// console.log(tYear,tMonth,tDate,tHours,tMinutes,tSeconds)
            return tYear.toString()+tMonth+tDate+tHours+tMinutes+tSeconds;
        },
        doHandleMonth(month){
            var m = month;
            if(month.toString().length == 1){
                m = "0" + month;
            }
            return m;
        },
        getDetail(){
			if(this.type=='add') return
			if(this.type=='query'){
				// 请求操作历史
				HttpSysOpLog({
					search: {
						EQ_opDataId: this.id,
						EQ_opModel: 'Product',
					},
                    rows:1000,
				}).then(res => {
					// console.log(res.data)
					this.logList = res.data.content
				}, err => {

				})
            }
            this.loading = true;
			HttpGetProductsOne({
				id:this.id
			}).then(res=>{
				// console.log(res.data)
                let {
                    battery,
                    ...formData
                } = {
                    ...res.data
                };
				// this.formData = res.data;
                this.formData = formData;
				this.handleResponse(res.data)
                if (res.data.isContainBattery) {
                    this.isShowBattery = true;
                    this.formData.batteryPower = battery ? battery.power : '--';
                    this.formData.batteryType = battery ? battery.type : '--';
                    this.formData.batteryPackageType = battery ? battery.packageType : '--';
                    this.formData.batteryWeight = battery ? battery.weight : null;
                    this.formData.batteryLabel = battery ? battery.label : 0;
                    this.formData.batteryLabelType = battery ? battery.labelType : '--';

                    if (this.formData.batteryPackageType == 0) {
                        this.isRequireBatteryWeight = true;
                    }
                    if (this.formData.batteryLabel) {
                        this.isRequireLabelType = true;
                    }
                }
                this.loading = false;

			},err=>{
                this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
                this.loading = false;
			})



		},
		// 请求品类列表
		getCategory(){
			HttpGetCategories().then(res=>{
				this.categoryList = res.data
			},err=>{
				this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
			})
		},
		handleResponse(data){
			// console.log(8989899)
			// console.log(data)
			this.formData.packages = data.packages || {}

			this.formData.packages.cartonPackedQty = data.cartonPackedQty;
            this.formData.packages.palletCartonQty = data.palletCartonQty;
			this.$set(this.$data, 'cleardata', data || {});
			this.$set(this.$data, 'imagedata', data || {});
			this.$set(this.$data, 'otherdata', data || {});


			this.formData.danwei1 = 1
			this.formData.staging1 = 1
			this.formData.danwei2 = 2
			this.formData.staging2 = 2
			this.formData.packages.danwei3 = 1
			this.formData.packages.staging3 = 1
			this.formData.packages.danwei4 = 2
			this.formData.packages.staging4 = 2

			this.titleName = data.codeName;
			// console.log(data)
			if(data.seasonalSalesCycle){
				let arr = data.seasonalSalesCycle.split(",")
				// console.log(arr)
				this.formData.seasonalSalesCycle1 = arr[0];
				this.formData.seasonalSalesCycle2 = arr[1];
			}

			// 数值进行转换之后展示 页面中数据从cm-》inch
			this.formData.length = this.getNumberfun(this.formData.length,'division',5)
			this.formData.width = this.getNumberfun(this.formData.width,'division',5)
			this.formData.height = this.getNumberfun(this.formData.height,'division',5)

			this.formData.packages.packedLength = this.getNumberfun(this.formData.packages.packedLength,'division',5)
			this.formData.packages.packedWidth = this.getNumberfun(this.formData.packages.packedWidth,'division',5)
			this.formData.packages.packedHeight = this.getNumberfun(this.formData.packages.packedHeight,'division',5)

			// weight g-》lb
			this.formData.weight = this.getNumberfun(this.formData.weight,'division',8)
			this.formData.packages.packedWeight = this.getNumberfun(this.formData.packages.packedWeight,'division',8)
			// console.log(this.formData.danwei1)

			// console.log(this.formData.packages)

		},
		handleModalplat(){
			this.operate={
				show:true,
				title:this.$t('erp.product.search_category',{defaultValue:'搜索品类'}),
				width:650,
			}
		},
		chosecategory(data){
			// console.log(data)
			this.$set(this.formData,'categoryCode',data.code)
			// 品类获取
			let array = this.getParentItem(data.id);
			let newarr = []
			// console.log(array)
			for(var i = array.length-1;i>=0;i--){
				newarr.push(array[i])
			}
			let title = newarr[1].name + "(" + newarr[1].nameEn + ") /" + newarr[2].name + "(" + newarr[2].nameEn + ") /" + newarr[3].name + "(" + newarr[3].nameEn + ")"

			this.$set(this.$data,'titleName',title)
		},
		getParentItem(parentId,result=[]){
			// console.log(this.categoryList)
			let parent = this.categoryList.find(val=> val.id == parentId)
			if(parent){
				result.push(parent)
			}
			if(parent && parent.parentId){
				this.getParentItem(parent.parentId,result)
			}
			return result

		},
		closemodal(){
			this.operate.show = false;
		},
		// 单位转换传值
		changeUnit(){
			let _this = this;
			// 基本信息的转换
			if(this.formData.danwei1 == 1){
				// 单位inch转成cm传值
				_this.formData.length = Number(_this.formData.length) * 2.54 || 0
				_this.formData.width = Number(_this.formData.width) * 2.54 || 0
				_this.formData.height = Number(_this.formData.height) * 2.54 || 0

				// 把单位1也转换成cm
				this.formData.danwei1 = 0
			}
			// 转成g传给后端
			if(this.formData.danwei2 == 1){
				_this.formData.weight = Number(_this.formData.weight) * 28.35|| 0;
				// 把单位转成g
				this.formData.danwei2 = 0
			}

			if(this.formData.danwei2 == 2){
				_this.formData.weight = Number(_this.formData.weight) * 453.592 || 0;
				// 把单位转成g
				this.formData.danwei2 = 0
			}

			if(_this.formData.packages.danwei3 == 1){
				_this.formData.packages.packedLength = Number(_this.formData.packages.packedLength) * 2.54 || 0
				_this.formData.packages.packedWidth = Number(_this.formData.packages.packedWidth) * 2.54 || 0
				_this.formData.packages.packedHeight = Number(_this.formData.packages.packedHeight) * 2.54 || 0
				// 把单位1也转换成cm
				_this.formData.packages.danwei3 = 0
			}

			if(_this.formData.packages.danwei4 == 1){
				_this.formData.packages.packedWeight = Number(_this.formData.packages.packedWeight) * 28.35 || 0

				_this.formData.packages.danwei4 = 0
			}

			if(_this.formData.packages.danwei4 == 2){
				_this.formData.packages.packedWeight = Number(_this.formData.packages.packedWeight) * 453.592 || 0

				_this.formData.packages.danwei4 = 0
			}

			return true
		},
		getProductsSize(){
			return HttpGetProductSize({
				weight:this.formData.weight,
				length:this.formData.length,
				width:this.formData.width,
				height:this.formData.height
			}).then(res=>{
				// console.log(res.data)
				return res.data
			},err=>{
				this.$VMessage.error({
                            content: err.message,
                            duration: 30,
                            closable: true
                        });
			})
		},
		// 获取销售定位
		getSaleLocation() {
			return HttpGetSaleLocation({}).then(res=> {
				return res.data
			}, err=> {
				this.$VMessage.error({
                            content: err.message,
                            duration: 30,
                            closable: true
                        });
			})
		},
		// 点击提交
		async submit(){

			let refclear = this.$refs.refcompclear
			let refimage = this.$refs.refcompimage
			let refother = this.$refs.refcompother

			// console.log(refclear)
			// 验证页面必填选项
			// 验证基本信息
			const valid1 = await this.$refs['baseform'].validate();
			if (!valid1) return;
			// 验证仓库信息
			if(this.warehouseInfo){
				const valid2 = await this.$refs['warehouseform'].validate();
				if (!valid2) return;
                // if (this.formData.isContainBattery && (this.formData.batteryLabel != 0 || this.formData.batteryLabel != 1)) {
                //     return this.$VMessage.error("是否已经张贴电池标必须填写");
                // }
			}
			// 验证头程信息
			if(this.packageInfo){
				const valid3 = await this.$refs['packageform'].validate();
				if (!valid3) return;
			}
			// // 验证采购信息
			// if(this.purchaseInfo){
			// 	const valid3 = await this.$refs['purchaseform'].validate();
			// 	if (!valid3) return;
			// }
			// 验证清关信息
			if(this.customsInfo){
				const valid4 = await this.$refs['refcompclear'].validate();
				if (!valid4) return;

				let flag = false;
				let fobpirce = false;
				// console.log(refclear.formList)
				if(refclear.formList.length>0){
                    refclear.formList.map(item=>{
						if(item.fobPrice>100000000000){
							fobpirce = true
						}
						// console.log(item)
                        if(item.countryCode===undefined || item.countryCode === '' || item.customCode===undefined || item.customCode === '' || item.importTaxRate===undefined || item.importTaxRate ==='' || item.customDiscountRate===undefined || item.customDiscountRate ===''){
							// console.log(45454545)
                            flag = true
                        }
                    })
				}
				if(fobpirce){
					this.$Message.error(this.$t('erp.product.fobprice_bigmorethan',{defaultValue:'fob填写不能大于 100000000000'}));
                    return;
				}
				if(flag){
                    this.$Message.error(this.$t('erp.product.cleartable_warning',{defaultValue:'清关信息table中带*号的必须填写'}));
                    return;
                }
			}
			// 判断基本信息里面的尺寸大于0
			if(this.formData.width==0 || this.formData.height==0 || this.formData.length==0){
				this.$VMessage.error(this.$t('erp.product.dimensions_morethan',{defaultValue:'单品外包装填写需大于0'}))
				return
			}
			if(this.formData.width>10000000 || this.formData.height>10000000 || this.formData.length>10000000){
				this.$VMessage.error(this.$t('erp.product.dimensions_bigmorethan',{defaultValue:'单品外包装填写不能大于 10000000'}))
				return
			}
			// 外箱尺寸
			if(this.formData.packages.packedLength>10000000 || this.formData.packages.packedWidth>10000000 || this.formData.packages.packedHeight>10000000){
				this.$VMessage.error(this.$t('erp.product.carton_bigmorethan',{defaultValue:'外箱尺寸填写不能大于 10000000'}))
				return
            }


			// 产品毛重
			if(this.formData.weight==0){
				this.$VMessage.error(this.$t('erp.product.weight_morethan',{defaultValue:'产品毛重填写需大于0'}))
				return
			}
			if(this.formData.weight>10000000){
				this.$VMessage.error(this.$t('erp.product.weight_bigmorethan',{defaultValue:'产品毛重填写不能大于 10000000'}))
				return
			}
			// 外箱毛重
			if(this.formData.packages.packedWeight>10000000){
				this.$VMessage.error(this.$t('erp.product.cartonweight_bigmorethan',{defaultValue:'外箱毛重填写不能大于 10000000'}))
				return
			}

            if (!this.autoGenrate) {
                // 验证erpsku
                var titleReg = /^([A-Za-z0-9-_./#]{3,50})$/;
                if(titleReg.test(this.formData.erpSku)===false && this.type == 'add'){
                    this.$VMessage.error(this.$t('erp.product.erpsku_conformity',{defaultValue:'ERPSKU输入不符合规范'}));
                    return
                }
            }

			//  走单位换算传给后端字段
			const bool = await this.changeUnit()

            // 外箱尺寸和外箱毛重是否大于等于单品外包装尺寸和毛重
            if(this.formData.packages.packedLength>0){
                if(this.formData.packages.packedLength < this.formData.length || this.formData.packages.packedWidth < this.formData.width || this.formData.packages.packedHeight < this.formData.height || this.formData.packages.packedWeight < this.formData.weight){
                    this.$VMessage.error(this.$t('erp.product.package_check',{defaultValue:'外箱尺寸比单品尺寸小 或 外箱毛重比产品毛重小，请核实！'}));
                    return
                }
            }

			const number = await this.getProductsSize()
            // console.log(number)



			// 列表尺寸范围的传值
			this.formData.packingSizeType = number;
			this.formData.cartonPackedQty = this.formData.packages.cartonPackedQty;
            this.formData.palletCartonQty = this.formData.packages.palletCartonQty;


            if(this.formData.seasonalSalesCycle1 == undefined || this.formData.seasonalSalesCycle2 == undefined){
				this.formData.seasonalSalesCycle = ''
			}else{
				this.formData.seasonalSalesCycle = this.formData.seasonalSalesCycle1 + ',' + this.formData.seasonalSalesCycle2
			}



			// 循环标签列表，并且传值后端
			let arr = []
			if(refother){
				for(let i=0;i<refother.choseList.length;i++){
					arr.push(refother.choseList[i].id)
				}
			}
            let str = arr.join(",")
            let {
                shapeType,
                materialType,
                shippingMethod,
                isMagnetism,
                isLiquid,
                isFragile,
                isContainBattery,

                ...formData
            } = {
                ...this.formData
            }
            // 电池
            let {
                batteryPower,
                batteryType,
                batteryPackageType,
                batteryWeight,
                batteryLabel,
                batteryLabelType,

                ...requestData
            } = {
                ...formData
            }
			let obj = {
				orgId:global.SYSID,
                ...requestData,
                // erpSku: this.autoGenrate ? '' : this.formData.erpSKu,
				customs:refclear ? refclear.formList : null,
				htsName:refclear ? refclear.formData.htsName : null,
				htsNameEn:refclear ? refclear.formData.htsNameEn : null,
				htsCode:refclear ? refclear.formData.htsCode : null,
				pictures:refimage ? refimage.formList : null,
				returnDealMethod:refother ? refother.formData.returnDealMethod : null,
				isDistribution:refother ? refother.formData.isDistribution : null,
                productMidCondition:refother ? refother.formData.productMidCondition : null,
                productMidModel:refother ? refother.formData.productMidModel : null,
                productMidMeta:refother ? refother.formData.productMidMeta : null,
                productMidStandard:refother ? refother.formData.productMidStandard : null,
				productLabel:str ? str : null,
			}
            obj["warehouse"] = {
                "packingType":this.formData.packingType,
                "isSignService":this.formData.isSignService,
                "isInsurance":this.formData.isInsurance,
                "insuranceRate":this.formData.insuranceRate,
                "expirationControl":this.formData.expirationControl,
                "expirationDate":this.formData.expirationDate,
                "expirationType":this.formData.expirationType,
                "prePackedQty":this.formData.prePackedQty,
                shapeType,
                materialType,
                shippingMethod,
                isMagnetism,
                isLiquid,
                isFragile,
                isContainBattery
            }
            obj["purchase"] = {
                "periodInAdvance":this.formData.periodInAdvance,
                "logisticsLeadTime":this.formData.logisticsLeadTime,
                "minOrderQty":this.formData.minOrderQty,
                "replenishmentCycle":this.formData.replenishmentCycle,
                "safetyStockDays":this.formData.safetyStockDays,
            }
            if (isContainBattery) {
                obj["batteryRequest"] = {
                    batteryPower,
                    batteryType,
                    batteryPackageType,
                    batteryWeight,
                    batteryLabel,
                    batteryLabelType
                }
            }
            else {
                obj["batteryRequest"] = {};
            }
            this.loading = true;
			HttpSaveProducts(obj).then(res=>{
				// console.log(res.data)
				this.$VMessage.success(res.message)
				this.$router.push({
                    name: "allproductsList"
                });
                this.loading = false;
			},err=>{
                this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
                this.loading = false;
			})
		},
		cancel(){
			if(this.querytype == 'edit'){
                this.$emit('on-close')
            }else{
                this.$router.push({
                    name: "allproductsList"
                })
            }
		}
    }
}
</script>
